export default "__VITE_ASSET__fNyMgP5M__"